import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
import { buildEditorialAlternates, buildEditorialCanonical, buildMagazineLinks } from '~/helpers/seo-helpers';
export default {
  name: 'Editorial',
  props: {
    type: {
      type: String,
      default: null
    },
    seo: {
      type: Object,
      required: true
    },
    page: {
      type: Number,
      default: null
    },
    totalPages: {
      type: Number,
      default: null
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: "LUX = window.LUX || {}; LUX.label = '".concat(this.type, "';")
      };
      return luxConfig;
    },
    canonical: function canonical() {
      var _ref5;

      var customCanonical = (_ref5 = this.seo) != null ? (_ref5 = _ref5.canonical) != null ? _ref5.url : _ref5 : _ref5;

      if (customCanonical) {
        return {
          rel: 'canonical',
          href: "".concat(customCanonical).concat(this.page && this.page !== 1 ? "?page=".concat(this.page) : '')
        };
      }

      return buildEditorialCanonical(this.baseURL, this.$route.path, this.page);
    },
    alternates: function alternates() {
      var _ref3, _ref4;

      var customAlternates = (_ref4 = this.seo) != null ? (_ref4 = _ref4.alternates) != null ? (_ref4 = _ref4[0]) != null ? (_ref4 = _ref4.url) != null ? _ref4.url : _ref4 : _ref4 : _ref4 : _ref4;
      var emptyAlternates = ((_ref3 = this.seo) != null ? _ref3.empty_alternates : _ref3) === 'true';

      if (customAlternates) {
        return this.seo.alternates.map(function (e) {
          return {
            rel: 'alternate',
            hreflang: e.hreflang,
            href: e.url.url
          };
        });
      }

      if (emptyAlternates) {
        return [];
      }

      if (this.type === 'home') {
        return buildEditorialAlternates(this.baseURL, this.type, false, false, true);
      }

      return buildEditorialAlternates(this.baseURL, this.type, this.$route.params.slug, this.$route.params.alias !== this.type ? this.$route.params.alias : false);
    },
    previousPage: function previousPage() {
      return this.page && this.page > 1 ? this.page - 1 : null;
    },
    nextPage: function nextPage() {
      return this.page && this.page < this.totalPages ? this.page + 1 : null;
    }
  }),
  methods: {
    generatePageLink: function generatePageLink(page, type) {
      if (!page) {
        return [];
      }

      if (page === 1) {
        return [buildMagazineLinks({
          base: this.baseURL,
          alias: this.$route.path ? this.$route.path.slice(1) : '',
          type: type
        })];
      }

      return [buildMagazineLinks({
        base: this.baseURL,
        alias: this.$route.path ? this.$route.path.slice(1) : '',
        type: type,
        page: page
      })];
    }
  },
  head: function head() {
    var _ref, _ref2;

    return {
      script: [this.speedcurveConfig],
      title: this.seo.meta_title ? "".concat(this.seo.meta_title, " | Maisons du Monde") : 'Maisons du Monde',
      link: [this.canonical].concat(_toConsumableArray(this.alternates), _toConsumableArray(this.generatePageLink(this.nextPage, 'next')), _toConsumableArray(this.generatePageLink(this.previousPage, 'prev'))),
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: ((_ref2 = this.seo) != null ? _ref2.meta_robots : _ref2) || 'noodp'
      }, {
        name: 'description',
        content: ((_ref = this.seo) != null ? _ref.meta_description : _ref) || ''
      }]
    };
  },
  render: function render(h) {
    return h(null);
  }
};